import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../utils/utils';
import { CreateWavePopupComponent } from './createwavepopup/createwavepopup.component';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';

@Component({
    selector: 'wave',
    templateUrl: './wave.component.html',
    styleUrls: ['./wave.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class WaveComponent implements OnInit {

    @Output() selectedWaveEmit = new EventEmitter<{}>();

    subscriptions: any[] = [];
    public dataSource = new MatTableDataSource<any>();
    columnsToDisplay = ['Select', 'Name', 'GroupFunction', 'StartDate', 'EndDate', 'actions', 'ChangeLog'];

    selectedWave: Wave;

    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private customDialog: CustomDialogService
        , public defaults: DefaultValuesService
        , private toastrService: ToastrService
        , private router: Router) {
        this.selectedWave = {
            WaveId: -1,
            Name: '',
            ChangedBy: ''
        }
    }

    ngOnInit(): void {
        // Just once to get user role in case of loading directly that component.
        // Remove actions item from columnsToDisplay
        if (!this.defaults.isMersyAdminBranchExcellenceUser)
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        this.getWaves();
    }

    getWaves() {
        Utils.httpGetWaves(
            this.http,
            this.baseUrl,
            this,
            function (tthis: WaveComponent, list: any) {
                tthis.dataSource.data = list
            },
            null

        )
    }

    resetSelectedWave() {
        this.selectedWave = {
            WaveId: -1,
            Name: '',
            ChangedBy: ''
        }
    }

    onEditWave(element: Wave) {
        const dialog = this.dialogForm.open(CreateWavePopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: element,
        })

        dialog.afterClosed().subscribe(() => {
            this.getWaves()
        })
    }

    openCreateWavePopup() {
        const dialog = this.dialogForm.open(CreateWavePopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
        })

        dialog.afterClosed().subscribe(() => {
            this.getWaves()
        })
    }

    onSelectWave(element: Wave) {
        if (this.selectedWave?.WaveId === element.WaveId)
            this.resetSelectedWave()
        else
            this.selectedWave = element;
        this.selectedWaveEmit.emit(this.selectedWave);
    }

    onHistoryDetail(element: Wave, type: string) {

        var waveId = 0;

        if (element.WaveId != undefined)
            waveId = element.WaveId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: waveId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }

    onClickDownloadBranchData() {
        Utils.httpDownloadWaveBranchData(
            this.http,
            this.baseUrl,
            `WaveBranchData_${this.selectedWave.Name}`,
            this.selectedWave.WaveId
        );
    }

    onClickUploadBranchData() {
        void this.router.navigate(["file/" + Utils.getFileUploadWaveBranchData() + "-" + this.selectedWave.WaveId]);
    }

    onRemoveWave(element: Wave) {
        this.customDialog.openConfirm({
            title: 'Delete Wave',
            message: `Are you sure you want to delete the wave "${element.Name}"?`,
            caller: this
        });

        this.customDialog.confirmed().subscribe(res => {
            if (!res?.confirmed)
                return;

            Utils.httpDeleteWaves(
                this.http,
                this.baseUrl,
                element.WaveId,
                this,
                function (tthis: WaveComponent, resp: any) {
                    resp ? tthis.toastrService.success('Wave was deleted successfully!', `Delete ${element.Name}`) : tthis.toastrService.error('Wave deletion failed!', `Delete ${element.Name}`);
                    tthis.getWaves()
                },
                null
            )
        });
    }

}
